var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSoloDisegno(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213.2,
    height: 52.531,
    viewBox: "0 0 213.2 52.531",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -141.98)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 2.401,
    y: 144.39,
    width: 208.4,
    height: 47.728
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    overflow: "visible",
    xlinkHref: "#SVGID_1_"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.963 .2697 -.2697 .963 47.533 -9.502)",
    x: 55.949,
    y: 142.22,
    width: 4.802,
    height: 52.058
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.3102 .9507 -.9507 .3102 220.66 32.408)",
    x: 61.634,
    y: 165.85,
    width: 52.728,
    height: 4.802
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.8513 .5247 -.5247 .8513 111.35 -55.354)",
    x: 150.93,
    y: 139.91,
    width: 4.802,
    height: 57.693
  })), /*#__PURE__*/React.createElement("path", {
    d: "m213.2 194.52h-213.2v-52.531h213.2zm-208.4-4.803h203.59v-42.926h-203.59z",
    fill: "current"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSoloDisegno);
export default __webpack_public_path__ + "static/media/logoSoloDisegno.7bd935e96ef3da9f2615ec344249e16b.svg";
export { ForwardRef as ReactComponent };